import { UserRole } from '@shared/types/user';
import { DIVIDER, MenuItem } from './menu-item.type';

export const SPIN_MACHINE_MENU_ITEMS: MenuItem[] = [
  {
    name: 'header.client',
    url: '/client',
    icon: 'Gear',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.clientBI',
    url: '/client-bi',
    icon: 'analytics',
    permission: [UserRole.Admin, UserRole.ClientAdmin, UserRole.Manager],
  },
  {
    name: 'header.games',
    url: '/spin-machine-games',
    icon: 'Games',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.users',
    url: '/users',
    icon: 'Users',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.campaigns',
    url: '/campaigns',
    icon: 'Radio',
    permission: [UserRole.Admin],
  },
  DIVIDER,
  {
    name: 'header.collectibles',
    url: '/collectibles',
    icon: 'Diamond',
    permission: [
      UserRole.Admin,
      UserRole.Supervisor,
      UserRole.Manager,
      UserRole.ClientAdmin,
    ],
  },
  {
    name: 'header.iconChance',
    url: '/icon-chances',
    icon: 'Icons',
    permission: [
      UserRole.Admin,
      UserRole.Supervisor,
      UserRole.Manager,
      UserRole.ClientAdmin,
    ],
  },
  DIVIDER,
  {
    name: 'header.actions',
    url: '/actions',
    icon: 'List',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.reporting',
    url: '/reporting',
    icon: 'Mail',
    permission: [
      UserRole.Admin,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.Manager,
    ],
  },
  {
    name: 'header.labels',
    url: '/labels',
    icon: 'Language',
    permission: [UserRole.Admin, UserRole.ClientAdmin],
  },
  {
    name: 'header.assets',
    url: '/assets',
    icon: 'Upload',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.theme',
    url: '/spin-machine-theme',
    icon: 'Droplet',
    permission: [UserRole.Admin, UserRole.ClientAdmin],
  },
  {
    name: 'header.tokenValidation',
    url: '/token-validation',
    icon: 'Security',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
    ],
  },
  {
    name: 'header.tasks',
    url: '/tasks',
    icon: 'Tasks',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.preview',
    url: '/preview',
    icon: 'Eye',
    permission: [UserRole.Admin],
  },
];
